import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "./ui/Icons";
import heroImg from "../image/img7.jpg";

const STATS = [
  { value: "94%", key: "design.heroStatAccuracy" },
  { value: "37", key: "design.heroStatDiseases" },
  { value: "7", key: "design.heroStatCrops" },
];

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative isolate overflow-hidden bg-agri-forestDeep">
      {/* The photograph is the ground, not a washed-out 20%-opacity texture. */}
      <img
        src={heroImg}
        alt="The AgriHyphen AI team inspecting a potato crop in a field in Ngozi, Burundi"
        className="absolute inset-0 h-full w-full object-cover object-center"
        fetchpriority="high"
      />
      <div className="absolute inset-0 photo-scrim" />
      {/* Extra weight on the left so the headline column always clears AA */}
      <div className="absolute inset-0 bg-gradient-to-r from-agri-forestDeep/85 via-agri-forestDeep/45 to-transparent" />

      <div className="relative container-x flex min-h-[46rem] flex-col justify-end pb-14 pt-[calc(var(--nav-h)+5rem)] sm:min-h-[48rem] sm:pb-16 lg:min-h-[52rem] lg:pb-20">
        <p className="kicker-light flex items-center gap-3">
          <span className="inline-block h-1.5 w-1.5 shrink-0 bg-agri-lime" />
          {t("design.heroEyebrow")}
        </p>

        <h1 className="mt-7 max-w-[16ch] text-balance font-display text-h1 font-semibold leading-[0.98] tracking-[-0.032em] text-white sm:text-h1Lg lg:text-display">
          {t("design.heroTitle")}
        </h1>

        <p className="mt-7 max-w-measure text-lede text-white/75">
          {t("design.heroDesc")}
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-3">
          <Link to="/test-ai" className="btn-lime">
            {t("design.heroCta")}
            <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
          <Link to="/info" className="btn-outline-light">
            {t("design.heroSecondaryCta")}
          </Link>
        </div>

        {/* Stat rail sits on the fold line — reads as an instrument panel,
            not three floating glass cards. */}
        <dl className="mt-14 grid max-w-2xl grid-cols-3 border-t border-white/20 pt-7 sm:mt-16">
          {STATS.map((s) => (
            <div key={s.key} className="pr-4">
              <dt className="sr-only">{t(s.key)}</dt>
              <dd className="figure text-[2rem] leading-none text-agri-lime sm:text-[2.5rem]">
                {s.value}
              </dd>
              <p className="mt-2.5 font-mono text-[0.6875rem] uppercase leading-tight tracking-[0.1em] text-white/65">
                {t(s.key)}
              </p>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
